import { isUndefined } from 'lodash';
import Link from 'next/link';
import { memo } from 'react';

import { Routes } from '~/constants/routes';

type GeneralLibraryMembersDescriptionProps = {
  membersCount: number | undefined;
  workspaceName: string;
  onGoToSettingsClick: () => void;
};

export const GeneralLibraryMembersDescription = memo(
  ({ onGoToSettingsClick, membersCount, workspaceName }: GeneralLibraryMembersDescriptionProps) => (
    <div className="flex flex-col gap-2">
      <h6 className="font-semibold ads:text-secondary text-12 text-pigeon-500">
        Members {isUndefined(membersCount) ? '' : `(${membersCount})`}
      </h6>
      <p className="ads:text-secondary text-14 text-pigeon-600">
        All users with access to {workspaceName} are automatically members of this library. You can manage those users{' '}
        <Link
          className="font-medium ads:text-accent text-jay-600"
          href={Routes.workspaceSettings.members}
          onClick={onGoToSettingsClick}
        >
          here
        </Link>
        .
      </p>
    </div>
  ),
);

GeneralLibraryMembersDescription.displayName = 'GeneralLibraryMembersDescription';
